<template>
  <div
    class="p-contentplans-writing-user-headings-list"
    :class="{ 'is-not-empty': items.length > 0 }"
  >
    <draggable
      :animation="200"
      dragClass="is-drag"
      :fallbackTolerance="1"
      :forceFallback="true"
      ghostClass="is-ghost"
      group="headings"
      handle="div[data-handle]"
      :list="items"
      class="p-contentplans-writing-user-headings-list__draggable is-sortable-dropping"
      @start="dragStart"
      @end="dragEnd"
    >
      <p
        v-if="!items.length"
        class="p-contentplans-writing-user-headings-list__note"
      >
        AIが生成したテキストをここで編集できます
      </p>
      <template v-else>
        <UserHeadingsListItem
          v-for="item in items"
          :key="item.id"
          :id="item.id"
          :level="item.level"
          :value="item.value"
          :errorAddHeading="errorAddHeading"
          :error="errors[item.id]"
          ref="items"
          @input="input"
          @insertHeading="insertHeading"
          @remove="remove"
        />
      </template>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import UserHeadingsListItem from '@/components/contentPlans/writing/UserHeadingsListItem';

export default {
  props: {
    errorAddHeading: {
      type: String,
      required: false
    },
    errors: {
      type: Object,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  components: {
    draggable,
    UserHeadingsListItem
  },
  methods: {
    dragStart() {
      document.documentElement.classList.add('is-sortable-dragging');
    },
    dragEnd() {
      document.documentElement.classList.remove('is-sortable-dragging');
    },
    input(id, level, value) {
      this.$emit('input', id, level, value);
    },
    insertHeading(id, level, value) {
      this.$emit('insertHeading', id, level, value);
    },
    remove(id) {
      this.$emit('remove', id);
    }
  }
};
</script>
